export type SalesOrderStatus =
  | 'DRAFT'
  | 'DRAFT_CUSTOMER'
  | 'PENDING'
  | 'SUBMITTED'
  | 'APPROVED'
  | 'PICKING'
  | 'SHIPPED'
  | 'CLOSED'
  | 'CANCELLED'
  | 'ERROR';

type GroupTypes =
  | 'all'
  | 'toSubmitted'
  | 'toPicking'
  | 'toShipped'
  | 'toClosed'
  | 'picking'
  | 'active'
  | 'irreversible'
  | 'toSubmittedOrCancelled'
  | 'submittedOrPicking'
  | 'draft'
  | 'shipped';

const Groups: Record<GroupTypes, SalesOrderStatus[]> = {
  all: [
    'DRAFT',
    'DRAFT_CUSTOMER',
    'PENDING',
    'SUBMITTED',
    'APPROVED',
    'PICKING',
    'SHIPPED',
    'CLOSED',
    'CANCELLED',
    'ERROR',
  ],
  draft: ['DRAFT', 'DRAFT_CUSTOMER'],
  submittedOrPicking: ['SUBMITTED', 'APPROVED', 'PICKING'],
  picking: ['PICKING'],
  shipped: ['SHIPPED', 'CLOSED'],

  toSubmittedOrCancelled: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'APPROVED', 'SUBMITTED', 'CANCELLED'],
  toSubmitted: ['DRAFT', 'DRAFT_CUSTOMER', 'APPROVED', 'SUBMITTED'],
  toPicking: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING'],
  toShipped: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING', 'SHIPPED'],
  toClosed: ['DRAFT', 'DRAFT_CUSTOMER', 'PENDING', 'SUBMITTED', 'APPROVED', 'PICKING', 'SHIPPED', 'CLOSED'],

  active: ['APPROVED', 'SUBMITTED', 'PICKING', 'SHIPPED'],
  irreversible: ['CANCELLED', 'DRAFT'],
};

export default { Groups };
